import * as types from "./withdrawalEmailTemplateActionTypes";

export default function withdrawalEmailTemplateReducer(
  state = { template: null },
  action
) {
  switch (action.type) {
    case types.CLEAR_TEMPLATE: {
      return { ...state, template: null };
    }
    case types.GET_TEMPLATE_SUCCESS: {
      let newData = {};
      newData = { ...state, template: action.payload.data };
      return { ...newData };
    }
    default: {
      return state;
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/withdrawal-configuration/withdrawalEmailTemplateReducer.js